module.exports = __webpack_public_path__ + "static/media/connect-logo.07de5a2f.svg";